<template>
    <v-timeline>
      <v-timeline-item
        class="mb-2"
        v-for="(val, index) in prestations"
        :key="index"
        v-bind:class="'text-right'"
        :color="val.complete ? 'blue' : 'grey'"
        :icon="val.complete ? 'mdi-check' : 'mdi-timer-sand'"
        :right="true"
      >
        <v-btn class="mt-2" color="transparent" small>{{ val.name }}</v-btn>
      </v-timeline-item>
    </v-timeline>
</template>

<script>

export default {
  props: ['prestations', 'booked_prestation'],
  name: 'treatmentTimeline',
  data: () => {
    return {
      item_in: [
        { name: 'Etablissement', complete: true },
        { name: 'Casier', complete: true },
        { name: 'Cabine', complete: true },
      ],
      item_out: [
        { name: 'Cabine', complete: true },
        { name: 'Ordonnance', complete: false },
        { name: 'Accueil', complete: false },
      ],
    }
  },
}
</script>